import {
  IDENTITY_PDF_MODAL_OPEN,
  IDENTITY_PDF_MODAL_CLOSE,
  IDENTITY_PDF_MODAL_RESET,
} from '../actions/pdf_modal_dialog'

export function identityPdfModalDialog(
  state = {
    isModalDialogOpen: false,
    content: null,
  },
  action
) {
  switch (action.type) {
    case IDENTITY_PDF_MODAL_OPEN:
      return {
        ...state,
        isModalDialogOpen: true,
        content: action.content,
      }
    case IDENTITY_PDF_MODAL_CLOSE:
      return {
        ...state,
        isModalDialogOpen: false,
      }
    case IDENTITY_PDF_MODAL_RESET:
      return {
        ...state,
        content: null,
      }
    default:
      return state
  }
}
